import {observable} from "mobx";
import {consoleApi} from "../apiMiddleware";
import {ServiceTypeEnum} from "../components/portal/serviceCenter/ProjectDetail";
export type PriceStat = {
    teamId: number;
    price: number;
    month: string;
};

export type ResBalanceData = { code: number, data: { balance: BalanceData } };
export type ResRechargesData = { code: number, data: { recharges: RechargeData[] } };
export type ResCouponData = { code: number, data: { coupons: CouponDatas[] } };

export type ResRecharge = { code: number, data: { recharge: {
            channelInfo: string;
            createdAt: string;
            currency: string;
            id: number;
            price: number;
            source: string;
            step: string;
            teamId: number;
            updatedAt: string;
        } } };

export type BalanceData = {
    id: number,
    teamId: number,
    balance: number,
    discount: number,
    currency: string,
    allowSource: string,
    createdAt: string,
    updatedAt: string,
};

export type RechargeData = {
    id: number,
    teamId: number,
    beforeBalance: number,
    afterBalance: number,
    price: number,
    step: string,
    source: string,
    currency: string,
    sourceChannelId: string | null,
    channelInfo: string | null,
    createdAt: string,
    updatedAt: string,
};

export type CouponDatas = {
    id: number,
    teamId: number,
    price: number,
    currency: string,
    reason: string,
    allowPriceSource: string,
    enable: boolean,
    used: boolean,
    endTime: string,
    startTime: string,
    createdAt: string,
    updatedAt: string,
};

export type ResBalanceAlertsData = {
    code: number,
    data: {
        balanceAlertSetting: {
            id: number,
            teamId: number,
            enable: boolean,
            alertLine: string,
            alertType: string,
            createdAt: string,
            updatedAt: string,
        },
    },
};

export type ResBalanceAlertsUpData = {
    code: number,
    data: {
        balanceAlertSetting: {
            enable: boolean,
            alertLine: string,
            alertType: string,
        },
    },
};

export type BalanceAlertSettingType = {
    id: number,
    teamId: number,
    enable: boolean,
    alertLine: string,
    alertType: string,
    createdAt: string,
    updatedAt: string,
};

export type OrderType = {
    key: string,
    id: number,
    orderPrice: number,
    startTime: string,
    endTime: string,
    currency: string,
    orderType: ServiceTypeEnum,
};

export class PriceStore {
    @observable
    public priceStats: PriceStat[];
    @observable
    public balanceData: number | null;
    @observable
    public resRecharges: ResRecharge | null;
    @observable
    public resCompletedRecharges: ResRechargesData | null;
    @observable
    public resPrepayRecharges: ResRechargesData | null;
    @observable
    public resCoupons: CouponDatas[] = [];
    @observable
    public resBillsListData: OrderType[] = [];
    @observable
    public enable: boolean | null = null;
    @observable
    public alertLine: string = "";
    @observable
    public alertType: string = "0";

    public async getMyBalanceAlert(): Promise<void> {
        try {
            const resp: ResBalanceAlertsData = await consoleApi.data.getBalanceAlertsData();
            if (resp.code === 200 && resp.data.balanceAlertSetting) {
                this.refreshBalanceAlert(resp.data.balanceAlertSetting);
            }
        } catch (err) {
        }
    }

    private refreshBalanceAlert(balanceAlertSetting: BalanceAlertSettingType): void {
        this.enable = balanceAlertSetting.enable;
        this.alertLine = balanceAlertSetting.alertLine;
        this.alertType = balanceAlertSetting.alertType;
    }

    public async uploadMyBalanceAlert(alertType: string, alertLine: string): Promise<void> {
        try {
            const resp = await consoleApi.data.uploadBalanceAlertsData(alertType, alertLine);
            if (resp.code === 200 && resp.data.balanceSetting) {
                this.refreshBalanceAlert(resp.data.balanceSetting);
            }
        } catch (err) {
        }
    }

    public async upDateMyBalanceAlert(alertType: string, alertLine: string, enable: boolean): Promise<void> {
        try {
            const resp: ResBalanceAlertsUpData = await consoleApi.data.upDateBalanceAlertsData(alertType, alertLine, enable);
            if (resp.code === 200) {
                await this.getMyBalanceAlert();
            }
        } catch (err) {
        }
    }

    public async getMyBalance(): Promise<void> {
        try {
            const resp: ResBalanceData = await consoleApi.data.getBalanceData();
            if (resp.code === 200) {
                this.balanceData = resp.data.balance.balance / 100;
            } else {
                this.balanceData = null;
            }
        } catch (err) {
        }
    }

    public async getCoupons(): Promise<void> {
        try {
            const resp: ResCouponData = await consoleApi.data.couponData();
            if (resp.code === 200) {
                this.resCoupons = resp.data.coupons.map(data => {
                    return {
                        id: data.id,
                        teamId: data.teamId,
                        price: data.price,
                        currency: data.currency,
                        reason: data.reason,
                        allowPriceSource: data.allowPriceSource,
                        enable: data.enable,
                        used: data.used,
                        endTime: data.endTime,
                        startTime: data.startTime,
                        createdAt: data.createdAt,
                        updatedAt: data.updatedAt,
                    };
                });
            }
        } catch (err) {
        }
    }

    public async getMyCompletedRecharges(): Promise<void> {
        try {
            const resp: ResRechargesData = await consoleApi.data.completedRechargesData();
            if (resp.code === 200) {
                this.resCompletedRecharges = resp;
            } else {
                console.log(resp.data);
            }
        } catch (err) {
        }
    }

    public async rechargeUrl(price: number): Promise<string | undefined> {
        try {
            const resp: ResRecharge = await consoleApi.data.rechargeWithAlipay(price);
            if (resp.code === 200) {
                this.resRecharges = resp;
                const url: {returnUrl: string} = JSON.parse(resp.data.recharge.channelInfo);
                return url.returnUrl;
            } else {
                throw new Error(`recharge err: ${resp.data}`);
            }
        } catch (err) {
        }
    }

}

export const priceStore = new PriceStore();



// WEBPACK FOOTER //
// ./src/models/PriceStore.ts